var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"spinner",attrs:{"width":"24","height":"24","viewBox":"0 0 48 48"}},[_c('circle',{staticClass:"spinner-path",attrs:{"cx":"24","cy":"24","r":"20","fill":"none","stroke-width":"6"}})])}
var staticRenderFns = []

export { render, staticRenderFns }